export default __webpack_public_path__ + "static/media/login_1.3e5432dd.png";